import React from 'react';
import CampaignScheduler from 'modules/campaigns/modules/common-campaign-form/components/CampaignScheduler/CampaignScheduler';
import { CampaignState } from 'modules/campaigns/modules/common-campaign-form/components/CampaignState/CampaignState';
import { ScheduleSectionFrame } from 'modules/campaigns/modules/common-campaign-form/components/ScheduleSectionFrame';
import TimeFrame from 'modules/campaigns/modules/common-campaign-form/components/TimeFrame/TimeFrame';

export const ScheduleSection = ({ isInitiallyCollapsed }) => (
    <ScheduleSectionFrame isInitiallyCollapsed={isInitiallyCollapsed}>
        <TimeFrame />
        <CampaignScheduler />
        <CampaignState />
    </ScheduleSectionFrame>
);

export default ScheduleSection;
